import GradientWeb from "./GradientWeb";
export default GradientWeb;
